
<div>
    <div class="header">
        <span>Update Prompt</span>
    </div>
    <div class="body">
        <div class="complete-txt">Please complete the following mandatory fields to update your prompt.</div>
        <div class="content-body">
            <form>
                <div class="form-field">
                    <label>Title <span class="required"></span><img src="/assets/icons/Icon_badge.svg" alt="" title="Use a clear and structured naming convention for easy identification." /></label>
                    <input type="text" [formControl]="title" [ngClass]="{'field-border': titleRequired,'disabled-dropdown': version > 0}"  required (ngModelChange)="onTitleChange($event)" />
                    <span class="field-required" *ngIf="titleRequired">  <img src="/assets/icons/Red.svg" alt="" class="red-icon"/> Title is required </span>
                </div>
                <div class="form-field">
                    <label>Category <span class="required"></span></label>
                  
                    <select [(ngModel)]="category_id" [ngClass]="{'field-border': categoryRequired,'disabled-dropdown': (variant>0 && version == 0)}" [ngModelOptions]="{ standalone: true }" required (change)="selectCategory($event)">
                        <option *ngFor="let category of categories" [value]="category.id">{{ category.name }}</option>
                    </select>
                    <span class="field-required" *ngIf="categoryRequired">  <img src="/assets/icons/Red.svg" alt="" class="red-icon"/> Category is required </span>
                </div>

                <div class="form-field" *ngIf="subcategories.length > 0">
                    <label>SubCategory<span class="required"></span></label>
                    <select type="text"  [ngClass]="{'field-border': SubcategoryRequired,'disabled-dropdown': (variant>0 && version == 0)}"  required (change)="selectSubCategory($event)">
                        <option *ngFor="let subCategory of subcategories" [value]="subCategory.id">{{subCategory.name}}</option>
                    </select>
                    <span class="field-required" *ngIf="SubcategoryRequired">  <img src="/assets/icons/Red.svg" alt="" class="red-icon"/> SubCategory is required </span>
                </div>

                <div class="form-field mn-height">
                    <label>Description <span class="required"></span></label>
                    <textarea cols="10" [ngClass]="{'field-border': fromGroup}" [formControl]="description" required (ngModelChange)="onChange($event)"></textarea>
                    <span class="field-required" *ngIf="fromGroup">  <img src="/assets/icons/Red.svg" alt="" class="red-icon"/> Description is required </span>
                </div>

                <div class="form-field">
                    <label>Estimated time for this step/sequence of steps <span class="required"></span></label>
                    <div class="time-field">
                        <div class="time-input-container">
                            <button class="time-btn plus" (click)="increaseHour()">+</button>
                            <input 
                                name="time"
                                class="value" 
                                type="text"  
                                placeholder="00.00"
                                [(ngModel)]="time"
                                (blur)="validateAndFormatTime()"
                                maxlength="5"
                                pattern="^([01]\d|2[0-3]):([0-5]\d)$" />
                            <button class="time-btn minus" (click)="decreaseHour()">−</button>
                        </div>
                        <span>hour(s)</span>
                    </div>
                    <span class="field-required" *ngIf="isSaveClicked && !time_val()">  <img src="/assets/icons/Red.svg" class="red-icon" alt="" /> Hours is required </span>
                </div>
            </form>
        </div>
    </div>
    <div>
        <div class="btn-div">
            <button class="plain-btn" (click)="onClose()">
                <img class="cancle" src="/assets/icons/Close.svg" alt="" />Cancel</button>
            <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Update'" [iconSrc]="'/assets/icons/cached.svg'" (onClick)="onSubmit()"></app-button>

        </div>
    </div>
</div>